import React from 'react';
import { Avatar, AvatarBadge } from '@chakra-ui/react';
import { PhotoIcon } from '../../utils/icons/photo';
import { Color } from 'src/theme/color';

export const IconAvatar = ({ isOwner, ...props }: any) => {
	return (
		<Avatar
			src={props.src}
			name={props.nickname}
			userSelect="none"
			{...props}
		>
			{isOwner && (
				<AvatarBadge
					cursor="pointer"
					onClick={props.onClick}
					borderRadius="5px"
					right="24px"
					w="22px"
					h="22px"
					border={`1px solid ${Color.GRAY_BORDER_LIGHT}`}
					bg={Color.BACKGROUND}
					top="-18px"
				>
					<PhotoIcon
						width="12px"
						height="12px"
						fill={Color.GRAY_BORDER_LIGHT}
					/>
				</AvatarBadge>
			)}
		</Avatar>
	);
};
